<template>
  <v-container>
    <v-dialog v-model="openFlag" persistent max-width="700px">
      <c-card class="white" :title="onDialogTitle">
        <div class="mt-2">
          <span class="red--text">*</span> 는 필수입력항목입니다.
        </div>
        <v-form lazy-validation ref="form">
          <v-container>
            <v-row align="center">
              <v-col cols="7">
                <v-row>
                  <v-col cols="12">
                    <span class="ml-1 mb-2">물품 분류</span><span class="red--text"> * </span>
                    <v-row justify="space-around">
                      <v-select
                        class="birth-select"
                        dense
                        v-model="type"
                        :items="lostItemTypeName"
                        solo
                        menu-props="{ offsetY: true}"
                        hide-details
                        required
                        :rules="[v => !!v]"
                        label="년도"
                        color="navy"
                      />
                    </v-row>

                    <v-divider class="mt-3"></v-divider>
                  </v-col>


                  <v-col cols="12">
                    <span class="ml-1 mb-2">습득 기사</span><span class="red--text"> * </span>
                    <v-row justify="space-around">
                      <v-text-field class="field-text-car" v-model="this.selectedDriverName" placeholder="" solo dense required :rules="[v => !!v]"
                                    disabled hide-details color="navy"></v-text-field>
                      <v-icon class="ml-1" @click="() => { this.selectedDriver = null; this.selectedDriverName = null; }">close</v-icon>
                      <c-btn class="ml-3" outlined color="blue"
                             @click="()=>{ this.searchDriverName = null; this.selectDriverMenu = true; }">기사검색
                      </c-btn>
                      <v-menu
                              v-model="selectDriverMenu"
                              :close-on-content-click="false"
                              :nudge-width="250"
                              :position-x="getMenuPositionX"
                              :position-y="getMenuPositionY"
                              max-height="600"
                      >
                        <c-card min-height="350px" min-width="350px" class="white">
                          <v-text-field v-model="searchDriverName" append-outer-icon="search"
                                        placeholder="이름" solo dense hide-details autofocus color="navy"></v-text-field>

                          <v-list>
                            <v-list-item>
                              <v-row>
                                <v-col cols="5">이름</v-col>
                                <v-col cols="7">연락처</v-col>
                              </v-row>
                            </v-list-item>
                            <v-divider></v-divider>
                            <div class="driverSearchList">
                              <v-list-item v-for="driver in filteredDriverList" @click="onSelectDriver(driver)">
                                <v-row>
                                  <v-col cols="5">
                                    {{driver.name}}
                                  </v-col>
                                  <v-col cols="7">{{driver.mobileNo}}</v-col>
                                </v-row>
                              </v-list-item>
                            </div>
                          </v-list>
                        </c-card>
                      </v-menu>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <span class="ml-1 mb-2">습득 차량</span><span class="red--text"> * </span>
                    <v-row justify="space-around">
                      <v-text-field class="field-text-car" v-model="vehiclePlateNo" placeholder="차량 번호" solo required :rules="[v => !!v]" hide-details
                                    disabled :autofocus="true" color="navy" maxlength="30"></v-text-field>
                      <v-text-field class="field-text-car" v-model="vehicleModel" placeholder="차량 종류" solo required :rules="[v => !!v]" hide-details
                                    disabled :autofocus="true" color="navy" maxlength="30"></v-text-field>
                      <v-icon class="ml-1" @click="() => { this.vehiclePlateNo = null; this.vehicleModel = null; }">close</v-icon>
                      <c-btn class="ml-3" outlined color="blue"
                             @click="()=>{ this.vehiclePlateNo = null; this.vehiclePlateNo = null; reqGetDriverList(); this.selectVehicleMenu = true; }">차량검색
                      </c-btn>
                      <v-menu
                              v-model="selectVehicleMenu"
                              :close-on-content-click="false"
                              :nudge-width="250"
                              :position-x="getMenuPositionX"
                              :position-y="getMenuPositionY"
                              max-height="600"
                      >
                        <c-card min-height="350px" min-width="350px" class="white">
                          <v-text-field v-model="searchVehicleName" append-outer-icon="search"
                                        placeholder="차량 번호" solo dense hide-details autofocus color="navy"></v-text-field>
                          <v-list>
                            <v-list-item>
                              <v-row>
                                <v-col cols="5">차량번호</v-col>
                                <v-col cols="7">모델명</v-col>
                              </v-row>
                            </v-list-item>
                            <v-divider></v-divider>
                            <div class="driverSearchList">
                              <v-list-item v-for="vehicle in filteredVehicleList" @click="onSelectVehicle(vehicle)">
                                <v-row>
                                  <v-col cols="5">
                                    {{vehicle.plateNo}}
                                  </v-col>
                                  <v-col cols="7">{{vehicle.modelName}}</v-col>
                                </v-row>
                              </v-list-item>
                            </div>
                          </v-list>
                        </c-card>
                      </v-menu>
                    </v-row>

                    <v-divider class="mt-3"></v-divider>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="5">
                <c-card outlined>
                  <v-row justify="center" align="center">
                    <v-img v-if="photoUrl" :src="photoUrl" aspect-ratio="1" contain></v-img>
                    <div v-else>
                      <v-icon size="100">camera</v-icon>
                    </div>
                  </v-row>
                  <v-row justify="center" align="center" class="mt-3">
                    <c-btn color="grey" outlined @click="onPickFile">사진추가</c-btn>
                    <input
                      type="file"
                      style="display: none"
                      ref="fileInput"
                      accept="image/*"
                      @change="onFilePicked"
                    />
                  </v-row>
                </c-card>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">습득일</span><span class="red--text"> * </span>
                <v-row justify="space-around">
                  <v-menu
                    :close-on-content-click="true"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <div style="width:200px">
                        <v-text-field
                          v-model="selectedGetDate"
                          prepend-icon="event"
                          readonly dense
                          v-on="on"
                        ></v-text-field>
                      </div>
                    </template>
                    <c-date-picker
                      v-model="selectedGetDate"
                      no-title scrollable
                    >
                    </c-date-picker>
                  </v-menu>

                  <c-time-picker
                    label=""
                    v-model="selectedGetTime"
                    :minute-interval="1"
                    :h-range="[0,24]"
                    :autoScroll="true"
                    :defaultAutoScrollValue="7"
                    inputWidth="200px"
                  />
                </v-row>

                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">

                <span class="ml-1 mb-2">분실물 요약</span>
                <v-text-field v-model="summary" solo required hide-details
                              :autofocus="true" color="navy"
                              maxlength="30"></v-text-field>

                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12" v-if="id">

                <span class="ml-1 mb-2">분실물 상태</span>
                <v-select
                  v-model="state"
                  :items="lostItemStateName"
                  solo
                  dense
                ></v-select>
                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">분실물 상세</span>
                <v-textarea
                  solo
                  auto-grow hide-details
                  v-model="detail"
                  maxlength="500"
                ></v-textarea>

                <v-divider class="mt-3"></v-divider>
              </v-col>

            </v-row>
            <v-row justify="center">
              <c-btn v-if="lostItemFormData" class="mr-1 mt-2" color="blue" outlined @click="onUpdateLostItem">수정</c-btn>
              <c-btn v-else class="mr-1 mt-2" color="blue" outlined @click="onAddLostItem">등록</c-btn>
              <c-btn class="mt-2" color="gray" outlined @click="openFlag = false">취소</c-btn>
            </v-row>
          </v-container>
        </v-form>

      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import { mask } from 'vue-the-mask';

  export default {
    directives: { mask },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      lostItemFormData: {
        type: Object,
        default: undefined
      },
      driverList: {
        type: Array,
        default: () => []
      },
      vehicleList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        openFlag: false,

        id: null,

        type: '가방/지갑',
        // selectType: ['가방/지갑', '의류', '휴대폰/전자기기', '기타'],
        vehiclePlateNo: null,
        vehicleModel: null,

        summary: null,
        detail: null,

        selectedGetDate: this.$func.curDateString(),
        selectedGetTime: this.$moment().format('HH:mm'),


        selectedDriverName: null,
        selectedDriver: null,

        searchDriverName: null,
        selectDriverMenu: false,

        searchVehicleName: null,
        selectVehicleMenu: false,

        photoImg: null,
        photoUrl: null,
      }
    },
    watch: {
      open(value) {
        this.initData();
        if(value && this.lostItemFormData) {
          const data = this.lostItemFormData;

          this.id = data.id;
          this.type = data.type.configName;

          const vehicle = data.vehicle.split('|');
          this.vehiclePlateNo = vehicle[0]? vehicle[0]: '';
          this.vehicleModel = vehicle[1]? vehicle[1]: '';

          const getDate = this.lostItemFormData.getDate.split(' ');
          this.selectedGetDate = getDate[0] || this.$func.curDateString();
          this.selectedGetTime = getDate[1] || this.$moment().format('HH:mm');

          this.summary = data.summary;
          this.detail = data.detail;

          this.selectedDriver = data.driver;
          this.selectedDriverName = data.driver.name;

          this.photoUrl = data.photoUrl? this.$func.getImgUrl(data.photoUrl) : null;
        }
        this.openFlag = value;
      },

      openFlag(value) {
        this.$emit('update:open', value);
      },

    },
    computed: {
      getMenuPositionX() {
        return window.innerWidth / 2;
      },
      getMenuPositionY() {
        return window.innerHeight / 2;
      },
      getBtnName() {
        return this.lostItemFormData ? '수정' : '등록';
      },
      onDialogTitle() {
        return this.lostItemFormData ? '분실물 정보 수정' : '분실물 등록';
      },
      filteredDriverList() {
        return this.driverList.filter(item => this.searchDriverName? item.name.indexOf(this.searchDriverName)>-1: true);
      },
      filteredVehicleList() {
        return this.vehicleList.filter(item => this.searchVehicleName? item.plateNo.indexOf(this.searchVehicleName)>-1: true);
      },
      lostItemTypeName() {
        return this.$store.state.config.lostItemType.map(item => item.configName);
      },
      lostItemStateName() {
        return this.$store.state.config.lostItemState.map(item => item.configName);
      },
    },
    methods: {
      initData() {
        this.type = this.lostItemTypeName[0];
        this.state = this.lostItemStateName[0];
        this.vehiclePlateNo = null;
        this.vehicleModel = null;
        this.selectedGetDate = this.$func.curDateString();
        this.selectedGetTime = this.$moment().format('HH:mm');
        this.summary = null;
        this.detail = null;

        this.selectedDriver = null;
        this.selectedDriverName = null;

        this.selectDriverMenu = false;
        this.searchDriverName = null;

        this.photoImg = null;
        this.photoUrl = null;
      },

      onAddLostItem() {
        if (!(this.$refs.form.validate())) {
          this.$store.commit('snackbar', {timeout : 2000 , msg: '비어있는 필드가 있습니다.'});
          return;
        }

        const formData = new FormData();
        formData.append('type', this.type);
        formData.append('state', this.state);
        formData.append('vehicle', this.vehiclePlateNo+'|'+this.vehicleModel);
        formData.append('driverId', this.selectedDriver.id);
        formData.append('getDate', this.selectedGetDate+' '+this.selectedGetTime);
        formData.append('summary', this.summary? this.summary: '');
        formData.append('detail', this.detail? this.detail: '');
        if(this.photoImg)
          formData.append('photo', this.photoImg);

        this.$emit('reqAddLostItem', formData);

      },

      onUpdateLostItem() {
        if (!(this.$refs.form.validate())) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
          return;
        }

        const formData = new FormData();
        formData.append('id', this.id);
        formData.append('state', this.state);
        formData.append('type', this.type);
        formData.append('vehicle', this.vehiclePlateNo+'|'+this.vehicleModel);
        formData.append('driverId', this.selectedDriver.id);
        formData.append('getDate', this.selectedGetDate+' '+this.selectedGetTime);
        formData.append('summary', this.summary? this.summary: '');
        formData.append('detail', this.detail? this.detail: '');
        if(this.photoImg)
          formData.append('photo', this.photoImg);

        this.$emit('reqUpdateLostItem', formData);

      },

      onSelectDriver(selected) {
        this.selectedDriver = selected;
        this.selectedDriverName = selected.name;
        this.selectDriverMenu = false;
        this.searchDriverName = null;
      },
      onSelectVehicle(selected) {
        this.vehiclePlateNo = selected.plateNo;
        this.vehicleModel = selected.modelName;
        this.selectVehicleMenu = false;
        this.searchVehicleName = null;

      },
      onPickFile() {
        this.$refs.fileInput.click();
      },
      onFilePicked(event) {
        const files = event.target.files;
        let filename = files[0].name;
        if (filename.lastIndexOf('.') <= 0) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '지원하는 형식이 아닙니다.'});
          return
        } else if (files[0].size > 1000000) { // 10MB
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '업로드 가능한 용량을 초과하였습니다.'});
          return
        }

        const fileReader = new FileReader();
        fileReader.addEventListener('load', () => {
          this.photoUrl = fileReader.result;
        });
        fileReader.readAsDataURL(files[0]);
        console.log('files: ', files[0])
        this.photoImg = files[0];
      },
      async reqGetDriverList() {
        try {
          let res;
          if(this.selectedDriver == null) {
            res = await this.$api.getVehiclesByDriver('all');
          }else {
            res = await this.$api.getVehiclesByDriver(this.selectedDriver.id);
          }
          if(res && res.data)
            this.vehicleList = res.data;

        } catch(err) {
          this.$store.commit('snackbar', {err, where:'getVehiclesByDriver'});
        }
      }

    },
    mounted() {

    }

  }
</script>
<style lang="scss" scoped>
  .field-text-car {
    width: 50px !important;
    margin: 0 10px !important;
  }
  .field-select-birth {
    width: 50px !important;
    margin: 0 10px !important;
  }
</style>
